import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import NatureOutlinedIcon from '@mui/icons-material/NatureOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutIcon from '@mui/icons-material/Logout';

export const navigationLinks = {
  main: [
    { id: 'home', text: 'Home', url: '/', icon: HomeOutlinedIcon },
    { id: 'shop', text: 'Shop', url: '/shop', icon: ShoppingBagOutlinedIcon },
    { id: 'about', text: 'About Us', url: '/about-us', icon: InfoOutlinedIcon },
    { id: 'contact', text: 'Contact', url: '/contact', icon: PhoneOutlinedIcon },
    { id: 'blog', text: 'Blog', url: '/blog', icon: ArticleOutlinedIcon },
  ],
  account: {
    authenticated: [
      { id: 'profile', text: 'My Profile', url: '/account/profile', icon: PersonOutlineOutlinedIcon },
      { id: 'orders', text: 'My Orders', url: '/shop/orders', icon: LocalShippingOutlinedIcon },
      { id: 'returns', text: 'My Returns', url: '/shop/returns', icon: AssignmentReturnOutlinedIcon },
      { id: 'basket', text: 'My Basket', url: '/shop/basket', icon: ShoppingBasketOutlinedIcon },
      { id: 'change-email', text: 'Update Email', url: '/account/change-email', icon: EmailOutlinedIcon },
      { id: 'change-password', text: 'Change Password', url: '/account/change-password', icon: LockOutlinedIcon },
      { id: 'logout', text: 'Logout', url: '/logout', icon: LogoutIcon }
    ],
    guest: [
      { id: 'login', text: 'Login', url: '/login', icon: LoginOutlinedIcon },
      { id: 'register', text: 'Register', url: '/register', icon: PersonAddOutlinedIcon }
    ]
  },
  help: [
    { id: 'faq', text: 'FAQ', url: '/support/faq', icon: ArticleOutlinedIcon },
    { id: 'returns', text: 'Make a Return', url: '/support/make-a-return', icon: AssignmentReturnOutlinedIcon }
  ],
  more: [
    { id: 'accessibility', text: 'Accessibility', url: '/accessibility', icon: AccessibilityNewOutlinedIcon },
    { id: 'sustainability', text: 'Sustainability', url: '/sustainability', icon: NatureOutlinedIcon }
  ]
};

export default navigationLinks;
